module.exports = __webpack_public_path__ + "static/media/kofa2_cr.3d78ad05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/injectionMoulds/kofa2_cr.jpg
// module id = 202
// module chunks = 0